export function IonosLogo() {
	return (
		<svg
			width='110'
			height='32'
			viewBox='0 0 254.2 74.1'
			xmlns='http://www.w3.org/2000/svg'
			aria-label='IONOS'
			role='img'
		>
			<path
				fill='#003d8f'
				d='M235,74.1c-1.3,0-2.5-.1-3.7-.4-5.4-1.1-10-4.4-12.8-9.1h0c-1.4-2.8-.5-6.1,2.1-7.7.9-.5,1.8-.8,2.9-.8,2,0,3.9,1.1,4.9,2.9l.2.3.6.8.8.8c1,.9,2.3,1.5,3.6,1.8,2.2.4,4.5,0,6.3-1.4,1.9-1.3,3-3.4,3.2-5.7.2-2.3-.6-4.5-2.2-6.1,0,0-18.4-19-18.8-19.5l-.9-1.3c-2.2-3.4-3.1-7.4-2.8-11.3.2-2.8,1-5.4,2.4-7.8l.8-1.4c1.5-2.1,3.4-3.8,5.6-5.1l.9-.7c8.8-4.9,20-1.8,25,7,.8,1.3,1,2.8.6,4.3-.4,1.5-1.4,2.7-2.7,3.5-.8.5-1.8.8-2.8.8-2,0-3.9-1.1-4.9-2.9-1.1-1.8-2.9-3.1-4.9-3.5-2.1-.4-4.3,0-6,1.4-1.7,1.3-2.7,3.2-2.8,5.3-.2,2.1.6,4.2,2,5.7l17.3,17.9c7.4,7.6,7.1,19.8-.5,27.1-3.6,3.5-8.4,5.4-13.4,5.4h0Z'
			/>
			<path
				fill='#003d8f'
				d='M180.2,74.1c-10.3,0-18.6-8.3-18.6-18.6V18.6C161.5,8.3,169.9,0,180.2,0s18.6,8.3,18.6,18.6h0v36.9c0,10.3-8.3,18.6-18.6,18.6ZM180.2,11.3c-4.1,0-7.4,3.3-7.4,7.4v36.8c0,4,3.2,7.3,7.2,7.4,0,0,.1,0,.2,0,4.1,0,7.4-3.3,7.4-7.4V18.6c0-4.1-3.3-7.3-7.4-7.4Z'
			/>
			<path
				fill='#003d8f'
				d='M107.8,38v30.5c0,3.1-2.5,5.6-5.6,5.6-3.1,0-5.6-2.5-5.6-5.6V14.7l11.2,23.3ZM138.2,59.5V5.6c-.1-3.1-2.8-5.5-5.9-5.4-2.9.1-5.3,2.5-5.4,5.4v30.5l11.2,23.3ZM107.3,3.2h0c-1-2-3-3.1-5.1-3.1-.4,0-.8,0-1.1.1-2.6.5-4.5,2.8-4.4,5.5v1.3l30.9,64.1c1,1.9,2.9,3,5,3.1.4,0,.9,0,1.3-.2,2.6-.5,4.4-2.8,4.4-5.4v-1.3S108.1,4.9,107.3,3.2Z'
			/>
			<path
				fill='#003d8f'
				d='M54.4,74.1c-10.3,0-18.6-8.3-18.6-18.6V18.6C35.8,8.3,44.1,0,54.4,0s18.6,8.3,18.6,18.6v36.8c0,10.3-8.3,18.6-18.6,18.6ZM54.4,11.3c-4.1,0-7.4,3.3-7.4,7.4,0,0,0,0,0,0v36.8c0,4.1,3.3,7.4,7.4,7.4,4.1,0,7.4-3.3,7.4-7.4h0V18.6c0-4.1-3.3-7.3-7.4-7.4Z'
			/>
			<path
				fill='#003d8f'
				d='M6.1,74.1c-3.4,0-6.1-2.7-6.1-6,0,0,0,0,0-.1V6C0,2.7,2.8,0,6.2,0c2.8,0,5.2,1.8,5.9,4.5,0,.1,0,.3.1.4v.3c0,.3,0,.7,0,1v61.7c0,3.4-2.7,6.1-6.1,6.1,0,0,0,0,0,0Z'
			/>
		</svg>
	);
}
